"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

class MTableGroupbar extends React.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "getItemStyle", (isDragging, draggableStyle) => (0, _objectSpread2.default)({
      // some basic styles to make the items look a bit nicer
      userSelect: "none",
      // padding: '8px 16px',
      margin: "0 ".concat(8, "px 0 0")
    }, draggableStyle));
    (0, _defineProperty2.default)(this, "getListStyle", isDraggingOver => ({
      // background: isDraggingOver ? 'lightblue' : '#0000000a',
      background: "#0000000a",
      display: "flex",
      width: "100%",
      padding: 8,
      overflow: "auto",
      border: "1px solid #ccc",
      borderStyle: "dashed"
    }));
    this.state = {};
  }
  render() {
    return /*#__PURE__*/React.createElement(_Toolbar.default, {
      style: {
        padding: 0,
        minHeight: "unset"
      }
    }, /*#__PURE__*/React.createElement(_reactBeautifulDnd.Droppable, {
      droppableId: "groups",
      direction: "horizontal",
      placeholder: "Deneme"
    }, (provided, snapshot) => /*#__PURE__*/React.createElement("div", {
      ref: provided.innerRef,
      style: this.getListStyle(snapshot.isDraggingOver)
    }, this.props.groupColumns.length > 0 && /*#__PURE__*/React.createElement(_Typography.default, {
      variant: "caption",
      style: {
        padding: 8
      }
    }, this.props.localization.groupedBy), this.props.groupColumns.map((columnDef, index) => {
      return /*#__PURE__*/React.createElement(_reactBeautifulDnd.Draggable, {
        key: columnDef.tableData.id,
        draggableId: columnDef.tableData.id.toString(),
        index: index
      }, (provided, snapshot) => /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
        ref: provided.innerRef
      }, provided.draggableProps, provided.dragHandleProps, {
        style: this.getItemStyle(snapshot.isDragging, provided.draggableProps.style)
      }), /*#__PURE__*/React.createElement(_Chip.default, (0, _extends2.default)({}, provided.dragHandleProps, {
        onClick: () => this.props.onSortChanged(columnDef),
        label: /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            float: "left"
          }
        }, columnDef.title), columnDef.tableData.groupSort && /*#__PURE__*/React.createElement(this.props.icons.SortArrow, {
          style: {
            transition: "300ms ease all",
            transform: columnDef.tableData.groupSort === "asc" ? "rotate(-180deg)" : "none",
            fontSize: 18
          }
        })),
        style: {
          boxShadow: "none",
          textTransform: "none"
        },
        onDelete: () => this.props.onGroupRemoved(columnDef, index)
      }))));
    }), this.props.groupColumns.length === 0 && /*#__PURE__*/React.createElement(_Typography.default, {
      variant: "caption",
      style: {
        padding: 8
      }
    }, this.props.localization.placeholder), provided.placeholder)));
  }
}
MTableGroupbar.defaultProps = {};
MTableGroupbar.propTypes = {
  localization: _propTypes.default.shape({
    groupedBy: _propTypes.default.string,
    placeholder: _propTypes.default.string
  })
};
var _default = exports.default = MTableGroupbar;